import { Controller } from '@hotwired/stimulus'
import mediumZoom from 'medium-zoom/dist/medium-zoom.min'

export default class extends Controller {
  connect() {
    const images = this.element.querySelectorAll('img')

    mediumZoom(images, {background: 'rgba(231,245,247, 0.9)'})
  }
}
